// extracted by mini-css-extract-plugin
module.exports = {"button":"idt-contextmenuexpanded_button__1nvzu","container":"idt-contextmenuexpanded_container__19aos"};